/*
  Collection grid — sort auto-submit.

  The sort <select> carries data-collection-sort. When the user changes it,
  this submits the enclosing filter form so the page reloads with the new
  ?sort_by=... param. Filters do not auto-submit (deliberate — the user is
  often toggling several checkboxes; the APPLY button is the explicit commit).

  Phase 13 will replace this with the Shopify Search & Discovery
  <facet-filters-form> Web Component (AJAX, no full reloads). The
  [data-collection-sort] attribute can stay; the listener becomes the only
  thing that needs swapping.
*/

(() => {
  document.addEventListener('change', (e) => {
    const sort = e.target.closest('[data-collection-sort]');
    if (!sort) return;
    const form = sort.closest('form');
    if (form) form.submit();
  });
})();
